import {
    CER_LOADING,
    SEND_CERTIFICATE,VERIF_SANITARIO,SEND_SANITARIO
  } from "../actions/CertificateActions";
  
  
  const initialState = {
    addRequestID: 0,
    loading: false,
    add: false,
    Sanitario: false,
    addSanitario: false
  };

  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CER_LOADING: {
          return {
            ...state,
            loading: true,
            add: false,
            Sanitario: false,
            addSanitario: false
          };
        }
      case SEND_CERTIFICATE: {
        return{
          ...state,
          addRequestID : action.data,
          loading: false,
          add : true,
          Sanitario: false,
          addSanitario: false
        }
      }
      case VERIF_SANITARIO: {
        return{
          ...state,
          loading: false,
          add : false,
          Sanitario: action.data,
          addSanitario: false
        }
      }
      case SEND_SANITARIO: {
        return{
          ...state,
          loading: false,
          add : false,
          Sanitario: false,
          addSanitario: action.data
        }
      }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  